<template>
  <div class="turntable">
    <div class="head">
      <!-- 新老客户tab -->
      <div class="account_tab">
        <div @click="switchAccountType('0')">
          <img src="/subject/turntable/xin.png" width="162" />
          <img
            src="/subject/turntable/xin_g.png"
            width="231"
            class="guang"
            v-if="account_type === '0'"
          />
        </div>
        <div @click="switchAccountType('1')">
          <img src="/subject/turntable/lao.png" width="162" />
          <img
            src="/subject/turntable/lao_g.png"
            width="231"
            class="guang_2"
            v-if="account_type === '1'"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 转盘位置 -->
      <div
        :class="['turntableView', account_type === '0' ? 'turntableView_xin' : 'turntableView_lao']"
      >
        <LuckyWheel
          class="LuckyWheel"
          ref="myLucky"
          width="265px"
          height="265px"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          :defaultConfig="defaultConfig"
          @start="startCallback"
          @end="endCallback"
        />
        <!-- 剩余次数 -->
        <div class="draws_number">剩余次数：{{ drawsNumber }}次</div>
      </div>
      <!-- 获得奖励列表 -->
      <div class="rewardsList">
        <img src="/subject/turntable/rewards_title.png" />
        <div class="rewards">
          <div v-for="item in this.turntablelogs" :key="item.id">{{ item.value }}</div>
          <div v-if="!userStatus">请登录后查看抽奖记录 ~</div>
        </div>
      </div>
      <div class="turntable_p">
        用户可前往用户中心 / App-我的 查看奖励到账情况。
      </div>
      <div class="turntable_button">
        <div @click="live800">咨询客服</div>
        <div @click="questFunction(3, 0)">前往交易</div>
      </div>
      <!-- 任务 -->
      <div class="turntable_quest" v-if="userStatus">
        <!-- 攒次数 -->
        <div class="quest_title" style="color:#7a30da;">攒次数</div>
        <!-- 新客户 -->
        <div class="quest_list">
          <!-- <div class="quest_title">新用户</div> -->
          <template v-for="item in questList">
            <div class="quest_item" v-if="item.id === 1 && account_type === '0'">
              <div class="quest_item_left">注册后，可得{{ item.awardnum }}次转盘机会</div>
              <div v-if="!item.sendStatus" class="quest_item_right" @click="questFunction(item.id)">
                前往注册
              </div>
              <div class="quest_item_right" v-else>
                已完成
              </div>
            </div>
            <div class="quest_item" v-if="item.id === 2 && account_type === '0'">
              <div class="quest_item_left">首次入金后，可得{{ item.awardnum }}次转盘机会</div>
              <div v-if="!item.sendStatus" class="quest_item_right" @click="questFunction(item.id)">
                前往入金
              </div>
              <div v-else class="quest_item_right">
                已完成
              </div>
            </div>
            <div class="quest_item" v-if="item.id === 3 && account_type === '0'">
              <div class="quest_item_left">首次交易，可得{{ item.awardnum }}次转盘机会</div>
              <div v-if="!item.sendStatus" class="quest_item_right" @click="questFunction(item.id)">
                前往交易
              </div>
              <div v-else class="quest_item_right">
                已完成
              </div>
            </div>
            <div class="quest_item" v-if="item.id === 5 && account_type === '1'">
              <div class="quest_item_left">
                使用{{ item.requirenum }}积分，可得{{ item.awardnum }}次转盘机会
              </div>
              <div class="quest_item_right" @click="questFunction(item.id)">
                我的积分
              </div>
            </div>
            <div class="quest_item" v-if="item.id === 4 && account_type === '1'">
              <div class="quest_item_left">
                月净入金>={{ item.requirenum }}美金，可得{{ item.awardnum }}次转盘机会
              </div>
              <div class="quest_item_right" @click="questFunction(item.id)">
                前往入金
              </div>
            </div>
          </template>
        </div>
        <!-- 老客户 -->
        <!-- <div class="quest_list">
          <div class="quest_title">老用户</div>
          <div class="quest_item">
            <div class="quest_item_left">
              注册后，可得1次转盘机会
            </div>
            <div class="quest_item_right">
              前往注册
            </div>
          </div>
          <div class="quest_item">
            <div class="quest_item_left">
              注册后，可得1次转盘机会
            </div>
            <div class="quest_item_right">
              前往注册
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 中奖弹窗 -->
    <el-dialog :visible.sync="controlDialog" width="90%">
      <div class="dialogTitle">
        恭喜你！
      </div>
      <div class="dialogCenter">{{ messageTitle }}</div>
      <div class="dialogButton" @click="closerDialog">
        开心收下
      </div>
    </el-dialog>
    <el-dialog :visible.sync="controlDialog2" width="90%">
      <div class="dialogTitle">
        温馨提示
      </div>
      <div class="dialogCenter">请前往H5端或APP端进行交易</div>
      <div class="dialogButton" @click="closerDialog2">
        确定
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  searchId,
  searchUserNum,
  luckDraw,
  searchUserHistory,
  getQuestList,
  exchangePoints,
} from '@/apis/info';
import awardId from './global';
import { getActicityParam } from '@/apis/transfer'
import { setToken } from "@/utils/cookies";
import { queryUserInfo } from '@/apis/user';
import { mapState, mapActions } from "vuex";
import { queryConfigValue, getFakebonus } from '@/apis/common';
import { getActiveDomain } from '@/utils/IMEI';
export default {
  data() {
    return {
      userStatus: 0,
      userKey: '',
      userAccount: '',
      messageTitle: '',
      account_type: '0',
      drawsNumber: 0,
      screenWidth: null,
      cjIndex: null,
      controlDialog: false,
      controlDialog2: false,
      turntablelogs: [],
      questList: [],
      // 转盘插件变量
      blocks: [
        {
          padding: '15px',
          imgs: [
            {
              src: '/subject/turntable/pc_xin_bj.png',
              width: '265px',
              height: '265px',
              top: '0px',
              rotate: true,
            },
          ],
        },
      ],
      prizes: [],
      buttons: [
        {
          radius: '25%',
          pointer: true,
          imgs: [
            {
              src: `/subject/turntable/pointer.png`,
              top: '-162px',
              width: '146px',
              height: '162px',
            },
            { src: `/subject/turntable/zpButton.gif`, top: '-40px', width: '73px', height: '73px' },
          ],
        },
      ],
      defaultConfig: {
        offsetDegree: -22,
      },
      // 判断是否在app打开
      isApp: false,
      queryInfo: {},//传递数据
      requestUrl:''

    };
  },
  created() {
    this.$emit('controlShow', true);
    // 判断用户是否是自己登陆
    if (this.$route.query.turntableKey) {
      sessionStorage.setItem('turntableKey', this.$route.query.turntableKey.replace(/ /g, '+'));
      setToken(this.$route.query.turntableKey.replace(/ /g, '+'));

    }

    if (this.$route.query.from) {
      this.isApp = true;
      this.queryInfo = this.$route.query;

      const key = this.$route.query.accessKey.replace(/ /g, '+');
      sessionStorage.setItem('turntableKey', key);
      setToken(key);

      this.userKey = key;
    }

    if (!sessionStorage.getItem('account')) {
      if (!this.$route.query.account && !this.$route.query.a) {
        this.userStatus = 0;
        this.account_type = '0';
        this.getPrizeList(awardId.newUserID);
        getQuestList();
      } else {
        sessionStorage.setItem('account', this.$route.query.account || this.$route.query.a);
        this.userAccount = this.$route.query.account || this.$route.query.a;
        this.userKey = sessionStorage.getItem('turntableKey');
        this.queryUserAccount(this.userKey);
        this.getQuestList();
      }
    } else {
      this.userStatus = 1;
      this.userKey = sessionStorage.getItem('turntableKey');
      this.queryUserAccount(this.userKey);
      this.getQuestList();
    }
    this.getRequest();
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  watch: {
    screenWidth: function (n) {
      if (n > 500) {
        this.$router.push({
          name: 'turntable',
        });
      }
    },
    account_type: function (type) {
      if (type === '0') {
        this.blocks[0].imgs[0].src = '/subject/turntable/pc_xin_bj.png';
      } else {
        this.blocks[0].imgs[0].src = '/subject/turntable/pc_lao_bj.png';
      }
    },
  },
  methods: {
    async getRequest() {
      const res = await queryConfigValue({ "key": "24HOnlineCustomerService" })
      
      if (!res) { return }
      else{
      this.requestUrl = await getActiveDomain(res);
    
      }
      
    },
    switchAccountType(type) {
      this.account_type = type;
      this.getPrizeList(Number(this.account_type) == 1 ? awardId.oldUserID : awardId.newUserID);
      if (sessionStorage.getItem('turntableKey')) {
        this.initUserNum(
          sessionStorage.getItem('account'),
          Number(this.account_type) == 1 ? awardId.oldUserID : awardId.newUserID
        );
        this.initUserHistory(sessionStorage.getItem('account'));
      }
    },
    ...mapActions('common', {
      getTradeWapLink: 'getTradeWapLink',
    }),
    // 抽奖
    startCallback() {
      if (!sessionStorage.getItem('account')) {
        this.loginMethod();
      } else {
        if (this.drawsNumber > 0) {
          let initData = {
            accountid: Number(sessionStorage.getItem('account')),
            turntableid: Number(this.account_type) == 1 ? awardId.oldUserID : awardId.newUserID,
          };
          luckDraw(initData).then((res) => {
            if (res.status === 0) {
              if (res.turntableLog) {
                // 调用抽奖组件的play方法开始游戏
                this.$refs.myLucky.play();
                // if (res.turntableLog.awardname.indexOf('赠')!==-1) {
                //   this.messageAll.messagePPP = res.turntableLog.awardname.split('赠')[0];
                // } else {
                //   this.messageAll.messagePPP = res.turntableLog.awardname;
                // }
                if (this.account_type === '0') {
                  switch (res.turntableLog.awardname) {
                    case '$20金银交易卡券':
                      this.cjIndex = 0;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '$20金银交易卡券';
                      break;
                    case '$50金银交易卡券':
                      this.cjIndex = 1;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '$50金银交易卡券';
                      break;
                    case '$100金银交易卡券':
                      this.cjIndex = 2;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '$100金银交易卡券';
                      break;
                    case '$200金银交易卡券':
                      this.cjIndex = 3;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '$200金银交易卡券';
                      break;
                    case '100美元现金':
                      this.cjIndex = 4;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '100美元现金';
                      break;
                    case '100美元赠金':
                      this.cjIndex = 5;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '100美元赠金';
                      break;
                    case '50美元赠金':
                      this.cjIndex = 6;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '50美元赠金';
                      break;
                    case '￥50微信红包':
                      this.cjIndex = 7;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '￥50微信红包';
                      break;
                  }
                } else {
                  switch (res.turntableLog.awardname) {
                    case '999美元赠金':
                      this.cjIndex = 0;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '999美元赠金';
                      break;
                    // case '299美元赠金':
                    //   this.cjIndex = 1
                    //   this.$refs.myLucky.stop(this.cjIndex)
                    //   this.messageTitle = '299美元赠金'
                    //   break
                    case '199美元赠金':
                      this.cjIndex = 1;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '199美元赠金';
                      break;
                    case '99美元赠金':
                      this.cjIndex = 2;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '99美元赠金';
                      break;
                    case '￥100现金':
                      this.cjIndex = 3;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '￥100现金';
                      break;
                    case '￥10现金':
                      this.cjIndex = 4;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '￥10现金';
                      break;
                    case '￥5现金':
                      this.cjIndex = 5;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '￥5现金';
                      break;
                    case '￥2现金':
                      this.cjIndex = 6;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '￥2现金';
                      break;
                    case '再来一次':
                      this.cjIndex = 7;
                      this.$refs.myLucky.stop(this.cjIndex);
                      this.messageTitle = '再来一次';
                      break;
                  }
                }
              } else {
                this.$message({
                  message: res.msg,
                  type: 'warning',
                });
              }
            } else {
              this.$message({
                message: '抽取奖励失败！',
                type: 'warning',
              });
            }
          });
        } else {
          this.$message({
            message: '您无可用的抽奖次数！',
            type: 'warning',
          });
        }
      }
    },
    // 抽奖结束
    endCallback() {
      this.cjIndex = null;
      this.controlDialog = true;
      this.initUserNum(
        sessionStorage.getItem('account'),
        Number(this.account_type) == 1 ? awardId.oldUserID : awardId.newUserID
      );
    },
    // 登录
    loginMethod() {
      window.location.href = window.location.origin + '/uc/login?' + 'turntable=turntable';
      // window.location.href = 'http://test.www.rlcproltd.com' + '/uc/login?' + 'turntable=turntable'
      // window.location.href = 'https://www.rlcproltd.net' + '/uc/login?' + 'turntable=turntable';
    },
    // 查询转盘
    getPrizeList(id) {
      searchId({ id: id }).then((res) => {
        if (res.status === 0) {
          this.prizes = [];
          res.awardlist.forEach((item, index) => {
            const prize = {
              imgs: [
                {
                  src: item.awardicon,
                  top: '10px',
                  width: '40px',
                  height: '45px',
                },
              ],
            };
            this.prizes.push(prize);
          });
        } else {
          this.$message({
            message: '获取转盘信息失败!',
            type: 'warning',
          });
        }
      });
    },
    // // 查询抽奖次数
    // initUserNum(attr, id) {
    //   let initData = {
    //       turntableid: id,     
    //   };
    //   searchUserNum(initData).then((res) => {
    //     if (res.status === 0) {
    //       this.drawsNumber = res.surplusnum;
    //     }
    //   });
    // },
    // 查询抽奖次数
    initUserNum(attr, id) {

      let datas = {
        "accountid": attr,
        "turntableid": id,
        "starttime": 1658678400000
      }
      getActicityParam('drawNumberApi', datas).then(res => {
        this.drawsNumber = res.surplusnum;
      })
    },
    // 查询账户是否为老客户
    queryUserAccount(key) {
      queryUserInfo().then(res => {
        console.log('用户信息-------', res)

        if (res.jfUser.isFirst == '1') {
          this.account_type = '1';
          this.getPrizeList(awardId.oldUserID);
          this.initUserNum(
            sessionStorage.getItem('account'),
            awardId.oldUserID
          );
          this.initUserHistory(sessionStorage.getItem('account'));
        } else {
          this.account_type = '0';
          this.getPrizeList(awardId.newUserID);
          this.initUserNum(
            sessionStorage.getItem('account'),
            awardId.newUserID
          );
          this.initUserHistory(sessionStorage.getItem('account'));
        }
      }).catch(() => {

      })


    },
    // 查询任务列表
    getQuestList() {
      getQuestList({}).then((res) => {
        console.log('任务列表----', res)
        this.questList = res;

        // if (res.IsSuccess) {
        //   this.questList = res.Data;
        // }
      });
    },

    // 查询历史抽奖结果
    initUserHistory(attr) {
      let initData = {
        turntablelog:
        {
          platform: 1, accountid: sessionStorage.getItem('account'),
          turntableid: Number(this.account_type) == 1 ? awardId.oldUserID : awardId.newUserID,
        }
      };
      getActicityParam('drawHistory', initData).then(res => {
        console.log('抽奖记录-----', res)

        let craigArr = [];
        if (res.turntablelogs) {
          res.turntablelogs.map((item) => {
            craigArr.push({
              value: item.awardname,
              id: item.id,
              time: this.formatDates(item.lotterytime)
            });
          });
          let r = craigArr.filter((item) => {
            return item.value != '未抽中';
          });
          this.turntablelogs = r;
          this.userStatus = 1;

        }

      })

    },
    formatDates(dateString) {
      // 解析日期时间字符串  
      const date = new Date(dateString);

      // 检查日期是否有效  
      if (isNaN(date.getTime())) {
        throw new Error('Invalid date string');
      }

      // 使用模板字符串格式化日期和时间  
      const formattedDate = `${date.getFullYear()}年${padZero(date.getMonth() + 1)}月${padZero(date.getDate())}日${padZero(date.getHours() + 8)}:${padZero(date.getMinutes())}`;

      return formattedDate;

      // 辅助函数：在数字前面添加前导零（如果需要）  
      function padZero(num) {
        return num.toString().padStart(2, '0');
      }
    },
    // 客服链接
    live800() {
      window.open(
        this.requestUrl
      );
    },
    closerDialog() {
      this.controlDialog = false;
      this.initUserHistory(sessionStorage.getItem('account'));
    },
    closerDialog2() {
      this.controlDialog2 = false;
    },
   
   async questFunction(id) {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (id === 1) {
        // 注册跳转
        if (isAndroid && window.android) {
          window.android.gotoLogin();
        } else if (isiOS) {
          try {
            window.webkit.messageHandlers.gotoLogin.postMessage('1');
          } catch (error) {
            window.location.href = window.location.origin + '/uc/signUp/real';
          }
        } else {
          window.location.href = window.location.origin + '/uc/signUp/real';
        }
      } else if (id === 2 || id === 4) {
        // 首次入金
        if (isAndroid && window.android) {
          window.android.gotoDeposit();
        } else if (isiOS) {
          try {
            window.webkit.messageHandlers.gotoDeposit.postMessage('1');
          } catch (error) {
            window.location.href = window.location.origin + '/uc/assets/deposit';
            // window.location.href = 'http://test.www.rlcvipltd.com' + '/uc/assets/deposit';

          }
        } else {
          if (this.queryInfo.fromUrl) {
            window.open(this.queryInfo.fromUrl + '/assets/deposit');

          } else {
            // 首次入金

            window.location.href = window.location.origin + '/uc/assets/deposit';

          }
        }
      } else if (id === 3) {
        // 首次交易
        if (isAndroid && window.android) {
          window.android.gotoTrade();
        } else if (isiOS) {
          try {
            window.webkit.messageHandlers.gotoTrade.postMessage('1');
          } catch (error) {

            if (this.queryInfo.fromUrl) {
              window.open(this.queryInfo.fromUrl + '/home/quote');
            } else {
              const h5LinkUrl = await this.getTradeWapLink();
              window.open(h5LinkUrl+ '/home/quote');
            }
          }
        } 
        else {
          if (this.queryInfo.fromUrl) {
            window.open(this.queryInfo.fromUrl + '/home/quote');
          } else {
            const h5LinkUrl = await this.getTradeWapLink();
            window.open(h5LinkUrl+ '/home/quote');
          }
        }
      } else if (id === 5) {
        // 兑换积分
        exchangePoints({}, this.userKey).then((res) => {
          if (res.IsSuccess) {
            this.$message({
              message: res.Data,
              type: 'success',
            });
          } else {
            this.$message({
              message: res.Data,
              type: 'error',
            });
          }

          this.initUserNum(
            sessionStorage.getItem('account'),
            Number(this.account_type) == 1 ? awardId.oldUserID : awardId.newUserID
          );
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.head {
  width: 100%;
  height: 526px;
  background-repeat: no-repeat;
  background-image: url('/subject/turntable/wap/banner.png');
  background-size: 100% 100%;
  position: relative;
  z-index: 2;
  margin-bottom: -100px;
  .account_tab {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    bottom: -42px;
    left: 0;
    > div {
      position: relative;
      &:nth-child(2) {
        margin-top: -2px;
      }
    }
    .guang {
      position: absolute;
      left: 50%;
      top: -50px;
      margin-left: -94px;
      z-index: -1;
    }
    .guang_2 {
      position: absolute;
      left: 0;
      top: -50px;
      margin-left: -49px;
      z-index: -1;
    }
  }
}
.content {
  width: 100%;
  // height: 1200px;
  padding-bottom: 80px;
  background-repeat: no-repeat;
  background-image: url('/subject/turntable/wap/bj.png');
  background-size: 100% 100%;
  position: relative;
  z-index: 1;
  padding-top: 160px;
  .turntableView {
    width: 330px;
    height: 403px;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    margin: 0 auto 0;
    .draws_number {
      width: 170px;
      font-size: 16px;
      color: #fff;
      font-weight: bold;
      text-align: center;
      line-height: 34px;
      position: absolute;
      bottom: 50px;
      left: 50%;
      margin-left: -85px;
    }
  }
  .turntableView_xin {
    background-image: url('/subject/turntable/xin_bj.png');
  }
  .turntableView_lao {
    background-image: url('/subject/turntable/lao_bj.png');
  }
  .rewardsList {
    width: 324px;
    height: 153px;
    background-repeat: no-repeat;
    background-image: url('/subject/turntable/rewards_bj.png');
    background-size: 100% 100%;
    margin: 24px auto 28px;
    > img {
      width: 124px;
      display: block;
      margin: 0 auto 6px;
    }
    .rewards {
      height: 87px;
      margin: 0 11px;
      padding: 6px 0;
      overflow-y: auto;
      font-size: 15px;
      color: #796c9d;
      text-align: center;
      > div {
        margin-bottom: 4px;
      }
    }
  }
  .turntable_p {
    font-size: 14px;
    color: #fff;
    text-align: center;
    margin-bottom: 20px;
  }
  .turntable_button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 28px;
    > div {
      width: 170px;
      height: 43px;
      line-height: 43px;
      text-align: center;
      font-size: 17px;
      color: #fff;
      font-weight: bold;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:nth-child(1) {
        background-image: url('/subject/turntable/button_1.png');
        margin-right: 6px;
      }
      &:nth-child(2) {
        background-image: url('/subject/turntable/button_2.png');
      }
    }
  }
  .turntable_quest {
    width: 325px;
    min-height: 339px;
    background-repeat: no-repeat;
    background-image: url('/subject/turntable/quest_bj.png');
    background-size: 100% 100%;
    margin: 0 auto;
    padding: 30px 13px;
    .quest_title {
      font-size: 15px;
      margin-bottom: 18px;
    }
    .quest_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 13px;
      .quest_item_left {
        font-size: 14px;
        color: #796c9d;
      }
      .quest_item_right {
        border: 1px solid #796c9d;
        width: 65px;
        height: 23px;
        font-size: 13px;
        color: #796c9d;
        text-align: center;
        line-height: 23px;
        border-radius: 5px;
      }
    }
  }
}
.LuckyWheel {
  position: relative;
  top: 30px;
  left: 31px;
}
.dialogTitle {
  font-size: 20px;
  color: #000000;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.dialogCenter {
  font-size: 14px;
  color: #3f3f3f;
  text-align: center;
  margin-bottom: 45px;
}
.dialogButton {
  width: 170px;
  height: 43px;
  line-height: 43px;
  text-align: center;
  font-size: 17px;
  color: #fff;
  font-weight: bold;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  background-image: url('/subject/turntable/button_2.png');
  margin: 0 auto;
}
</style>
